"use strict";
'kiwi public';

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));

var _isNan = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/number/is-nan"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/toConsumableArray"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));

var _trimEnd = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim-end"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));

var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));

var Misc = _interopRequireWildcard(require("@/helpers/Misc"));

var _lodash = _interopRequireDefault(require("lodash"));

var _AliasRewriter = _interopRequireDefault(require("./AliasRewriter"));

// Map of commandName=commandHandlerFn
var inputCommands = {};

var InputHandler = /*#__PURE__*/function () {
  function InputHandler(state) {
    var _this = this;

    (0, _classCallCheck2.default)(this, InputHandler);
    this.state = state;
    this.aliasRewriter = new _AliasRewriter.default(); // Load the aliases from general settings

    this.aliasRewriter.importFromString(state.setting('aliases')); // Only watch the user setting changes in order to reload them

    state.$watch('user_settings.aliases', function (newVal) {
      _this.aliasRewriter.importFromString(state.setting('aliases'));
    });
    this.listenForInput();
  }

  (0, _createClass2.default)(InputHandler, [{
    key: "defaultContext",
    value: function defaultContext() {
      return {
        network: this.state.getActiveNetwork(),
        buffer: this.state.getActiveBuffer()
      };
    }
  }, {
    key: "validateContext",
    value: function validateContext(context) {
      if ((0, _typeof2.default)(context) !== 'object' || !Object.prototype.hasOwnProperty.call(context, 'buffer') || !Object.prototype.hasOwnProperty.call(context, 'network') || (0, _typeof2.default)(context.buffer) !== 'object' || (0, _typeof2.default)(context.network) !== 'object') {
        throw new TypeError('context must contain both network and buffer properties');
      }
    }
  }, {
    key: "listenForInput",
    value: function listenForInput() {
      var _this2 = this;

      this.state.$on('input.raw', function (input) {
        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this2.defaultContext();
        var lines = input.split('\n');
        (0, _forEach.default)(lines).call(lines, function (line) {
          return _this2.processLine(line, context);
        });
      });
    }
  }, {
    key: "processLine",
    value: function processLine(rawLine) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.defaultContext();
      this.validateContext(context);
      var network = context.network,
          buffer = context.buffer;
      var line = rawLine;
      var stylesStrippedLine = Misc.stripStyles(line); // If no command specified, server buffers = send raw, channels/queries = send message

      var escapedCommand = stylesStrippedLine.substr(0, 2) === '//';

      if (stylesStrippedLine[0] !== '/' || escapedCommand) {
        if (escapedCommand) {
          line = line.substr(1);
        }

        if (buffer.isServer()) {
          line = '/quote ' + line;
        } else {
          line = '/msg ' + buffer.name + ' ' + line;
        }
      } else if (stylesStrippedLine[0] === '/' && line[0] !== '/') {
        // If attempting to send a /command but it has a colour code in front, use the
        // style stripped version of the line
        line = stylesStrippedLine;
      }

      var aliasVars = {
        network: network.name,
        server: network.connection.server,
        channel: network.isChannelName(buffer.name) ? buffer.name : '',
        query: network.isChannelName(buffer.name) ? '' : buffer.name,
        destination: buffer.name,
        nick: network.nick
      };
      line = this.aliasRewriter.process(line, aliasVars); // An alias rewrite may have cancelled out the input

      if (!line) {
        return;
      } // Remove the / from the start of the line


      line = line.substr(1);
      var spaceIdx = (0, _indexOf.default)(line).call(line, ' ');
      if (spaceIdx === -1) spaceIdx = line.length;
      var command = line.substr(0, spaceIdx);
      var params = line.substr(spaceIdx + 1);
      var eventObj = {
        handled: false,
        raw: rawLine,
        command: command,
        params: params
      }; // Plugins may tap into this event to handle a command themselves

      this.state.$emit('input.command.' + command, eventObj, command, params);

      if (eventObj.handled) {
        return;
      }

      if (inputCommands[command.toLowerCase()]) {
        inputCommands[command.toLowerCase()].call(this, eventObj, command, params);
      }

      if (!eventObj.handled) {
        network.ircClient.raw(line);
      }
    }
  }]);
  return InputHandler;
}();
/**
 * The actual handler functions for commands. Called in context of the InputHandler instance
 * inputCommand['the /command name'] = function(){};
 */
// /lines allows aliases to send multiple commands, separated by |


exports.default = InputHandler;

inputCommands.lines = function inputCommandLines(event, command, line) {
  var _context,
      _this3 = this;

  event.handled = true;
  (0, _forEach.default)(_context = line.split('|')).call(_context, function (subLine) {
    _this3.processLine((0, _trim.default)(subLine).call(subLine));
  });
};

function handleMessage(type, event, command, line) {
  event.handled = true;
  var network = this.state.getActiveNetwork();
  var spaceIdx = (0, _indexOf.default)(line).call(line, ' ');
  if (spaceIdx === -1) spaceIdx = line.length;
  var bufferName = line.substr(0, spaceIdx);
  var message = line.substr(spaceIdx + 1); // Only trim whitespace from the end if we have existing content. Some people enjoy sending
  // pure whitespace messages which we don't want to interfere with

  if (message.replace(/\s+/g, '') !== '') {
    message = (0, _trimEnd.default)(message).call(message);
  } else {
    // Windows uses \r\n for new lines as we split on \n trim \r from the end
    message = message.replace(/[\r]+$/, '');
  } // Make sure we have some text to actually send


  if (!message) {
    return;
  }

  var localBuffer = bufferName;
  var extractedTarget = network.ircClient.network.extractTargetGroup(bufferName);

  if (extractedTarget) {
    localBuffer = extractedTarget.target;
  }

  var buffer = localBuffer.length && this.state.getOrAddBufferByName(network.id, localBuffer);

  if (buffer) {
    var textFormatType = 'privmsg';

    if (type === 'action') {
      textFormatType = 'action';
    } else if (type === 'notice') {
      textFormatType = 'notice';
    }

    var messageBody = TextFormatting.formatText(textFormatType, {
      nick: network.nick,
      text: message
    });
    var newMessage = {
      time: (0, _now.default)(),
      nick: network.nick,
      message: messageBody,
      type: type
    };
    this.state.addMessage(buffer, newMessage);
  }

  var fnNames = {
    privmsg: 'say',
    action: 'action',
    notice: 'notice'
  };
  var fnName = fnNames[type] || 'say';
  network.ircClient[fnName](bufferName, message);
}

inputCommands.msg = function inputCommandMsg(event, command, line) {
  handleMessage.call(this, 'privmsg', event, command, line);
};

inputCommands.action = function inputCommandMsg(event, command, line) {
  handleMessage.call(this, 'action', event, command, line);
};

inputCommands.notice = function inputCommandMsg(event, command, line) {
  handleMessage.call(this, 'notice', event, command, line);
};

inputCommands.dice = function inputCommandDice(event, command, line) {
  // /dice 100
  event.handled = true;
  var buffer = this.state.getActiveBuffer();
  var network = this.state.getActiveNetwork();
  var sides = line.replace(/\D/g, '');
  sides = (0, _parseInt2.default)(sides || '0', 10);

  if (sides <= 0) {
    sides = 6;
  }

  var rndNumber = Math.floor(Math.random() * sides) + 1;
  var msg = TextFormatting.t('dice_roll', {
    sides: TextFormatting.formatNumber(sides),
    number: TextFormatting.formatNumber(rndNumber)
  });
  network.ircClient.action(buffer.name, msg);
  this.state.addMessage(buffer, {
    nick: network.nick,
    message: msg,
    type: 'action'
  });
};

inputCommands.ctcp = function inputCommandCtcp(event, command, line) {
  var _network$ircClient, _context2;

  event.handled = true;
  var params = line.split(' ');
  var target = params.shift();
  var ctcpType = params.shift();

  if (!ctcpType || !target) {
    return;
  }

  var network = this.state.getActiveNetwork();

  (_network$ircClient = network.ircClient).ctcpRequest.apply(_network$ircClient, (0, _toConsumableArray2.default)((0, _concat.default)(_context2 = [target, ctcpType]).call(_context2, params)));
};

inputCommands.join = function inputCommandJoin(event, command, line) {
  var _this4 = this;

  event.handled = true;
  var network = this.state.getActiveNetwork();
  var bufferObjs = Misc.extractBuffers(line); // handle join without any buffers specified

  if (bufferObjs.length === 0) {
    var buffer = this.state.getActiveBuffer(); // join the active channel if its not joined

    if (buffer.isChannel() && !buffer.joined) {
      network.ircClient.join(buffer.name, buffer.key);
      return;
    } // report an error if the user tries to join without specifying the channel


    this.state.addMessage(buffer, {
      nick: '*',
      message: TextFormatting.t('error_no_channel_join'),
      type: 'error'
    });
    return;
  } // Only switch to the first channel we join if multiple are being joined


  var hasSwitchedActiveBuffer = false;
  (0, _forEach.default)(bufferObjs).call(bufferObjs, function (bufferObj, idx) {
    // /join 0 parts all channels and is only ever used to troll IRC newbies.
    // Just disable it entirely.
    if (bufferObj.name === '0') {
      return;
    } // Prepend a # channel prefix if not specified already


    var chanName = network.isChannelName(bufferObj.name) ? bufferObj.name : '#' + bufferObj.name;

    var newBuffer = _this4.state.addBuffer(network.id, chanName);

    if (newBuffer && !hasSwitchedActiveBuffer) {
      _this4.state.setActiveBuffer(network.id, newBuffer.name);

      hasSwitchedActiveBuffer = true;
    }

    if (bufferObj.key) {
      newBuffer.key = bufferObj.key;
    }

    network.ircClient.join(chanName, bufferObj.key);
  });
};

inputCommands.part = function inputCommandPart(event, command, line) {
  event.handled = true;
  var network = this.state.getActiveNetwork();
  var bufferNames = [];
  var message = '';

  if (line === '') {
    // /part
    bufferNames = [this.state.getActiveBuffer().name];
  } else {
    var lineParts = line.split(' ');

    if (network.isChannelName(lineParts[0])) {
      // /part #channel,#possible_channel possible part message
      bufferNames = _lodash.default.compact(lineParts[0].split(','));
      message = (0, _slice.default)(lineParts).call(lineParts, 1).join(' ');
    } else {
      // /part possible part message
      bufferNames = [this.state.getActiveBuffer().name];
      message = line;
    }
  }

  (0, _forEach.default)(bufferNames).call(bufferNames, function (bufferName) {
    network.ircClient.part(bufferName, message);
  });
};

inputCommands.quit = function inputCommandQuit(event, command, line) {
  event.handled = true;
  var network = this.state.getActiveNetwork();
  network.ircClient.quit(line);
};

inputCommands.topic = function inputCommandTopic(event, command, line) {
  event.handled = true;
  var network = this.state.getActiveNetwork();
  var bufferName = '';
  var newTopic = '';

  if (line === '') {
    // /topic
    return;
  }

  var lineParts = line.split(' ');

  if (network.isChannelName(lineParts[0])) {
    // /topic #channel a topic
    bufferName = lineParts[0];
    newTopic = (0, _slice.default)(lineParts).call(lineParts, 1).join(' ');
  } else {
    // /topic a topic
    bufferName = this.state.getActiveBuffer().name;
    newTopic = line;
  }

  network.ircClient.setTopic(bufferName, newTopic);
};

inputCommands.kick = function inputCommandKick(event, command, line) {
  event.handled = true;
  var network = this.state.getActiveNetwork();
  var toKick = '';
  var bufferName = '';
  var kickReason = '';

  if (line === '') {
    // No params given
    return;
  }

  var lineParts = line.split(' ');

  if (network.isChannelName(lineParts[0])) {
    bufferName = lineParts.shift();
  }

  toKick = lineParts.shift();
  kickReason = lineParts.join(' ');

  if (!bufferName) {
    bufferName = this.state.getActiveBuffer().name;
  }

  if (!toKick) {
    return;
  }

  network.ircClient.raw('KICK', bufferName, toKick, kickReason);
};

inputCommands.ignore = function inputCommandIgnore(event, command, line) {
  event.handled = true;
  var network = this.state.getActiveNetwork();
  var toIgnore = line.split(' ').shift();

  if (!toIgnore) {
    return;
  }

  var user = this.state.getUser(network.id, toIgnore);

  if (user) {
    user.ignore = true;
    var buffer = this.state.getActiveBuffer();
    this.state.addMessage(buffer, {
      nick: '*',
      message: 'Ignoring ' + user.nick,
      type: 'message'
    });
  }
};

inputCommands.unignore = function inputCommandUnignore(event, command, line) {
  event.handled = true;
  var network = this.state.getActiveNetwork();
  var toUnignore = line.split(' ').shift();

  if (!toUnignore) {
    return;
  }

  var user = this.state.getUser(network.id, toUnignore);

  if (user) {
    user.ignore = false;
    var buffer = this.state.getActiveBuffer();
    this.state.addMessage(buffer, {
      nick: '*',
      message: 'No longer ignoring ' + user.nick,
      type: 'message'
    });
  }
};

inputCommands.close = function inputCommandClose(event, command, line) {
  var _this5 = this;

  event.handled = true;
  var network = this.state.getActiveNetwork();

  var bufferNames = _lodash.default.compact(line.split(/[, ]/));

  if (bufferNames.length === 0) {
    bufferNames = [this.state.getActiveBuffer().name];
  }

  (0, _forEach.default)(bufferNames).call(bufferNames, function (bufferName) {
    var buffer = network.bufferByName(bufferName);

    if (!buffer) {
      return;
    }

    _this5.state.removeBuffer(buffer);
  });
};

inputCommands.query = function inputCommandQuery(event, command, line) {
  event.handled = true;
  var pos = (0, _indexOf.default)(line).call(line, ' ');

  if (pos === -1) {
    pos = line.length;
  }

  var nick = line.substr(0, pos);
  var message = line.substr(pos + 1);
  var network = this.state.getActiveNetwork();
  var buffer = this.state.getOrAddBufferByName(network.id, nick);
  this.state.setActiveBuffer(network.id, buffer.name);

  if (message) {
    this.state.$emit('input.raw', '/msg ' + buffer.name + ' ' + message);
  }
};

inputCommands.invite = function inputCommandInvite(event, command, line) {
  var _context3;

  event.handled = true;
  var network = this.state.getActiveNetwork();
  var buffer = this.state.getActiveBuffer();
  var lineParts = line.split(' ');
  var nick = lineParts.shift();
  var channel = lineParts.shift();

  if (!channel) {
    channel = buffer.name;
  }

  if (!network.isChannelName(channel)) {
    return;
  }

  network.ircClient.raw('INVITE', nick, channel);
  this.state.addMessage(buffer, {
    nick: '*',
    message: (0, _concat.default)(_context3 = "Invited ".concat(nick, " to ")).call(_context3, channel),
    type: 'message'
  });
};

inputCommands.nick = function inputCommandNick(event, command, line) {
  event.handled = true;
  var spaceIdx = (0, _indexOf.default)(line).call(line, ' ');
  if (spaceIdx === -1) spaceIdx = line.length;
  var newNick = line.substr(0, spaceIdx);
  var network = this.state.getActiveNetwork();
  network.ircClient.changeNick(newNick);
};

inputCommands.away = function inputCommandAway(event, command, line) {
  event.handled = true;
  var network = this.state.getActiveNetwork();
  network.ircClient.raw('AWAY', line || 'Currently away');
};

inputCommands.back = function inputCommandAway(event, command, line) {
  event.handled = true;
  var network = this.state.getActiveNetwork();
  network.ircClient.raw('AWAY');
};

inputCommands.quote = function inputCommandQuote(event, command, line) {
  event.handled = true;
  var network = this.state.getActiveNetwork(); // Sending a manual CAP command triggers raw CAPs to be shown in the server tab

  if (line.split(' ')[0].toLowerCase() === 'cap') {
    network.setting('show_raw_caps', true);
  }

  var buffer = this.state.getActiveBuffer();

  if (buffer.isServer()) {
    this.state.addMessage(buffer, {
      time: (0, _now.default)(),
      nick: '',
      message: line
    });
  }

  network.ircClient.raw(line);
};

inputCommands.whois = function inputCommandWhois(event, command, line) {
  var _this6 = this;

  event.handled = true;
  var parts = line.split(' ');
  var network = this.state.getActiveNetwork();
  var buffer = this.state.getActiveBuffer();
  network.ircClient.whois(parts[0], parts[0], function (whoisData) {
    if (whoisData.error) {
      var messageBody = TextFormatting.formatText('whois_error', {
        nick: whoisData.nick,
        text: whoisData.error
      });

      _this6.state.addMessage(buffer, {
        time: (0, _now.default)(),
        nick: '',
        message: messageBody,
        type: 'error'
      });

      return;
    }

    var out = [];

    var display = function display(message) {
      if (!message) {
        return;
      }

      out.push(message);
    };

    var formats = {
      mask: 'is {{nick}}!{{user}}@{{host}} * ({{real_name}})',
      from: 'is connecting from {{actual_hostname}} {{actual_ip}}',
      channels: 'is on {{channels}}',
      server: 'is using {{server}} ({{server_info}})',
      operator: '{{operator}}',
      modes: '{{modes}}',
      account: 'is logged in as {{account}}',
      registered_nick: '{{registered_nick}}',
      secure: 'is using a secure connection',
      idle: 'has been idle for {{idle}}',
      logon: 'connected on {{logon}}',
      // The following entries will be ignored from whoisData as display() ignores
      // empty lines.
      nick: '',
      user: '',
      ident: '',
      hostname: '',
      real_name: '',
      actual_ip: '',
      server_info: '',
      actual_hostname: ''
    }; // Display a select few entries first to keep a consistent order, and then
    // show any extra information at the end

    if (whoisData.nick && whoisData.hostname) {
      display(formats.mask.replace('{{nick}}', whoisData.nick).replace('{{user}}', whoisData.ident).replace('{{host}}', whoisData.hostname).replace('{{real_name}}', whoisData.real_name));
    }

    if (whoisData.actual_hostname && whoisData.actual_ip) {
      display(formats.from.replace('{{actual_hostname}}', whoisData.actual_hostname).replace('{{actual_ip}}', whoisData.actual_ip));
    }

    if (whoisData.channels) {
      display(formats.channels.replace('{{channels}}', whoisData.channels));
    }

    if (whoisData.server) {
      display(formats.server.replace('{{server}}', whoisData.server).replace('{{server_info}}', whoisData.server_info));
    }

    if (whoisData.operator) {
      display(formats.operator.replace('{{operator}}', whoisData.operator));
    }

    if (whoisData.modes) {
      display(formats.modes.replace('{{modes}}', whoisData.modes));
    }

    if (whoisData.account) {
      display(formats.account.replace('{{account}}', whoisData.account));
    }

    if (whoisData.registered_nick) {
      display(formats.registered_nick.replace('{{registered_nick}}', whoisData.registered_nick));
    }

    if (whoisData.secure) {
      display(formats.secure);
    }

    if (whoisData.idle) {
      var idleSeconds = Math.floor((0, _parseInt2.default)(whoisData.idle, 10));
      display(formats.idle.replace('{{idle}}', TextFormatting.formatDuration(idleSeconds)));
    }

    if (whoisData.logon) {
      var logonTime = (0, _parseInt2.default)(whoisData.logon, 10);

      if (!(0, _isNan.default)(logonTime)) {
        var logonDate = new Date(logonTime * 1000);
        display(formats.logon.replace('{{logon}}', logonDate));
      }
    }

    _lodash.default.each(whoisData, function (val, key) {
      // Only include lines we haven't already used
      if (typeof formats[key] === 'undefined') {
        // Some keys such as `special` are arrays of values
        if (_lodash.default.isArray(val)) {
          (0, _forEach.default)(val).call(val, function (v) {
            var _context4;

            return display((0, _concat.default)(_context4 = "".concat(key, ": ")).call(_context4, v));
          });
        } else {
          var _context5;

          display((0, _concat.default)(_context5 = "".concat(key, ": ")).call(_context5, val));
        }
      }
    });

    (0, _forEach.default)(out).call(out, function (l) {
      _this6.state.addMessage(buffer, {
        nick: parts[0],
        message: l,
        type: 'whois'
      });
    });
  });
};

inputCommands.whowas = function inputCommandWhowas(event, command, line) {
  var _this7 = this;

  event.handled = true;
  var parts = line.split(' ');
  var network = this.state.getActiveNetwork();
  var buffer = this.state.getActiveBuffer();
  network.ircClient.whowas(parts[0], parts[0], function (whowasData) {
    var _context6;

    if (whowasData.error) {
      var messageBody = TextFormatting.formatText('whowas_error', {
        nick: whowasData.nick,
        text: whowasData.error
      });

      _this7.state.addMessage(buffer, {
        time: (0, _now.default)(),
        nick: '',
        message: messageBody,
        type: 'whowas'
      });

      return;
    }

    (0, _forEach.default)(_context6 = ['whowas_ident', 'whowas_server']).call(_context6, function (prop) {
      var messageBody = TextFormatting.formatText(prop, {
        nick: whowasData.nick,
        ident: whowasData.ident,
        host: whowasData.hostname,
        name: whowasData.real_name,
        server: whowasData.server,
        info: whowasData.server_info
      });

      _this7.state.addMessage(buffer, {
        time: (0, _now.default)(),
        nick: whowasData.nick,
        message: messageBody,
        type: 'whowas'
      });
    });
  });
};

inputCommands.mode = function inputCommandMode(event, command, line) {
  event.handled = true; // /mode [target] [+-modes]

  var network = this.state.getActiveNetwork();
  var buffer = this.state.getActiveBuffer();
  var target = buffer.isChannel() ? buffer.name : network.nick;

  var parts = _lodash.default.compact(line.split(' '));

  if (line && line[0] !== '+' && line[0] !== '-') {
    target = parts.shift();
  }

  if (parts[0]) {
    // parts[0] = the mode(s)
    // parts[1] = optional mode arguments
    // If we're asking for a ban list, show the response in the active channel
    if (parts[0] === '+b' && !parts[1]) {
      (0, _flags.default)(buffer).requested_banlist = true; // An IRCd may fuck up and simply not reply to a MODE command. Give a few seconds
      // for it to reply and if not, ignore our request was sent

      (0, _setTimeout2.default)(function () {
        (0, _flags.default)(buffer).requested_banlist = false;
      }, 4000);
    }

    network.ircClient.mode(target, parts[0], (0, _splice.default)(parts).call(parts, 1));
  } else {
    // No modes specified will request the modes for the target
    network.ircClient.mode(target);

    if (target === buffer.name) {
      // If we have requested modes for the active channel then flag it to show
      // the response in the buffer itself. Wait a few seconds before removing
      // the flag as there is no way to determine that everything has been received.
      (0, _flags.default)(buffer).requested_modes = true;
      (0, _setTimeout2.default)(function () {
        (0, _flags.default)(buffer).requested_modes = false;
      }, 4000);
    }
  }
};

inputCommands.names = function inputCommandNames(event, command, line) {
  event.handled = true; // /names [#channel]

  var network = this.state.getActiveNetwork();
  var args = line;

  if (!args) {
    args = this.state.getActiveBuffer().name;
  }

  network.ircClient.raw('NAMES ' + args);
};

inputCommands.inject = function inputCommandInject(event, command, line) {
  event.handled = true;
  var network = this.state.getActiveNetwork();
  var connection = network.ircClient.connection;
  connection.addReadBuffer(line);
};

inputCommands.clear = function inputCommandClear(event, command, line) {
  event.handled = true;
  var buffer = this.state.getActiveBuffer();
  buffer.clearMessages();
  this.state.addMessage(buffer, {
    nick: '*',
    message: 'Scrollback cleared'
  });
};

inputCommands.echo = function inputCommandEcho(event, command, line) {
  event.handled = true;
  var buffer = this.state.getActiveBuffer();
  this.state.addMessage(buffer, {
    nick: '*',
    message: line
  });
};

inputCommands.set = function inputCommandEcho(event, command, line) {
  var _context8, _context9;

  event.handled = true;
  var buffer = this.state.getActiveBuffer();
  var setting = '';
  var spacePos = (0, _indexOf.default)(line).call(line, ' ');

  if (spacePos > -1) {
    var _context7;

    // Anything after the space becomes the new setting value
    // false = boolean false
    // true = boolean true
    // off = boolean false
    // on = boolean true
    // "false" = string false
    // "true" = string true
    setting = line.substr(0, spacePos);
    var value = (0, _trim.default)(_context7 = line.substr(spacePos + 1)).call(_context7);

    switch ((0, _trim.default)(_context8 = value.toLowerCase()).call(_context8)) {
      case 'true':
      case 'on':
        value = true;
        break;

      case 'false':
      case 'off':
        value = false;
        break;

      default:
    } // Unquote any quoted values
    // ie.  "true" should jsut be the string true


    if (value[0] === '"' && value[value.length - 1] === '"') {
      value = value.substr(1, value.length - 2);
    }

    this.state.setting(setting, value);
  } else {
    setting = line;
  }

  this.state.addMessage(buffer, {
    nick: '*',
    message: (0, _concat.default)(_context9 = "".concat(setting, " = ")).call(_context9, this.state.setting(setting))
  });
};

inputCommands.list = function inputCommandList(event, command, line) {
  event.handled = true;
  var network = this.state.getActiveNetwork();

  if (!network.channel_list.length && network.channel_list_state !== 'updating') {
    network.channel_list_state = 'updating';
    network.ircClient.raw('LIST ' + line);
  }

  network.showServerBuffer('channels');
};

inputCommands.server = function inputCommandServer(event, command, line) {
  event.handled = true;
  var parts = line.split(' ');
  var serverAddr = parts[0];
  var serverPort = parts[1] || 6667;
  var serverTls = false;
  var serverPassword = parts[2];
  var nick = parts[3] || 'ircuser';

  if (serverPort[0] === '+') {
    serverTls = true;
    serverPort = (0, _parseInt2.default)(serverPort.substr(1), 10);
  } else {
    serverTls = false;
    serverPort = (0, _parseInt2.default)(serverPort, 10);
  }

  this.state.addNetwork(serverAddr, nick, {
    server: serverAddr,
    port: serverPort,
    tls: serverTls,
    password: serverPassword
  });
};

inputCommands.beep = function inputCommandBeep(event, command, line) {
  event.handled = true;
  this.state.$emit('audio.bleep');
};

inputCommands.notify = function inputCommandNotify(event, command, line) {
  event.handled = true;
  this.state.$emit('notification.show', line);
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["InputHandler"]
window._kiwi_exports.libs.InputHandler = exports.default ? exports.default : exports;
